import { render, staticRenderFns } from "./addRemove.vue?vue&type=template&id=9c31e7b0&scoped=true"
import script from "./addRemove.vue?vue&type=script&lang=js"
export * from "./addRemove.vue?vue&type=script&lang=js"
import style0 from "./addRemove.vue?vue&type=style&index=0&id=9c31e7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c31e7b0",
  null
  
)

export default component.exports